<template>

  <div class="content_dashboard" v-if="proofLoginStatus">

  	<h1 class="accountcustom">Empfangsportal</h1>

  	<div class="woocommerce-error" role="alert" v-if="summaryerror">Fehler. {{ summaryerrordescription }}</div>

  	<div class="activateFormular">
  		test
 	</div>

  </div>

</template>

<script>
import axios from 'axios';

export default {
	data() {
		return {
			apiResponse: '', // initial loading or error messages.
			wpPosts: [], // REST API response data goes here.
			wpData, // global data made available via wp_localize_script.
			user: {
				username: '',
				password: ''
			},
			summaryerror: false,
			summaryerrordescription: ''
		};
	},

	beforeMount() {
		//this.isLoggedIn();
	},

	computed: {
      	proofLoginStatus() {
      		if (this.$store.getters.isPortinvoiceLoggedIn == "") {
      			window.location.href = 'https://vali-e.com/konto/';
      		} else {
      			//if (this.$store.getters.getZammadID != "" && this.$store.getters.getZammadToken != "") {
      				this.$router.push('/');
      			//} else {
      				//return true;
      			//}
      		}
      	}
	},

	mounted() {
		this.user.username = this.$store.getters.getUserEmail;
	},

	methods: {
		activateSupportsystem() {
			this.$store.commit('setLoadingWorkingScreen')

			//if user.username == ''
			//hier noch die Mail, Firstname und Lastname in Wordpress speichern
			// var data = {
	  //           'nonce': this.wpData.nonce,
	  //           'email': this.user.username
	  //       }
	  //       console.log(data)
			// this.$store.dispatch('addEmail', data)
			// 	.then(resp => {
			// 		console.log(resp)
			// 	}
		 //        .catch(err => {
		 //        	console.log(err)
		 //        })	

			this.summaryerror = false
			var data = {
	            'nonce': this.wpData.nonce,
	            'restURL': this.wpData.rest_url,
	            'password': this.user.password
	        }
			this.$store.dispatch('initializeZammad', data)
		        .then(resp => {
		        	this.$store.commit('setStopLoadingWorkingScreen')
		        	if (resp == "success") {
		        		this.$router.push('/');
		        	} else {
			        	if (resp == "error1") {
			        		this.summaryerror = true
			        		this.summaryerrordescription = "Das Passwort stimmt nicht überein."
			        	} else if (resp == "error2") {
			        		this.summaryerror = true
			        		this.summaryerrordescription = "Fehler beim Anlegen."
			        	} else if (resp == "error3") {
			        		this.summaryerror = true
			        		this.summaryerrordescription = "Der Nutzer ist schon vergeben."
			        	} else {
			        		this.summaryerror = true
			        		this.summaryerrordescription = "Es ist ein unbekannter Fehler aufgetaucht."
			        	}
			        }
		        })
		        .catch(err => {
		        	this.summaryerror = true
		        	this.summaryerrordescription = err
		        	console.log(err)
		        })	

		}

	}
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NoAccess.vue